import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CustomTable from "../../../Components/Common/Table";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Card, CardBody, CardHeader, Col, Container, Row, Button, Modal, ModalBody, ModalHeader, ButtonToolbar, Input } from "@/Components/ui";
;
import { BACKEND_HOST, getUserInfo } from "../../../api";
import { API, IS_TEST } from "../../../api/client";
import type { UserInfo } from "@/api/type";
import { canManageSiteScopedCommerce } from "@/common/permissions";
import { dialogService } from "@/utils/dialogService";
export default function ShoppingProducts() {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [delRecord, setDelRecord] = useState(null);
    const [modalDelete, setModalDelete] = useState(false);
    const [itemCount, setItemCount] = useState(0);
    const [newArr, setNewArr] = useState([]);
    const [rawData, setRawData] = useState([]);
    const [currentUser, setCurrentUser] = useState<UserInfo | null>(null);
    const canManageCommerce = useMemo(() => canManageSiteScopedCommerce(currentUser), [currentUser]);
    function tog_delete() {
        setModalDelete(!modalDelete);
    }
    useEffect(() => {
        getUserInfo().then((data) => {
            console.log("ReservationProducts user:", data);
            setCurrentUser(data);
        });
    }, []);
    const guardOwnerAction = useCallback(async (action: () => void) => {
        if (!canManageCommerce) {
            await dialogService.handleAlert("지점 소유자 또는 최상위 관리자만 작업할 수 있습니다.");
            return;
        }
        action();
    }, [canManageCommerce]);
    const handleEdit = useCallback((id: number) => {
        void guardOwnerAction(() => {
            console.log("handleEdit", id);
            navigate(`/shopping-product-form/${id}`);
        });
    }, [guardOwnerAction, navigate]);
    const handleCopy = useCallback((id: number) => {
        void guardOwnerAction(() => navigate(`/shopping-product-form/${id}?copy=true`));
    }, [guardOwnerAction, navigate]);
    const handleDelete = useCallback((id: number) => {
        void guardOwnerAction(() => {
            setDelRecord(id);
            tog_delete();
        });
    }, [guardOwnerAction]);
    useEffect(() => {
        console.log("itemCount changed:", itemCount);
    }, [itemCount]);
    useEffect(() => {
        let fetch_url = `${BACKEND_HOST}/shop/product/?mode=true&include_hidden=true`;
        if (IS_TEST) {
            fetch_url = fetch_url + "&is_test=true";
        }
        API.get(fetch_url)
            .then((res) => {
            console.log(res.data);
            const newCountArr = res.data.map((item: any) => {
                return {
                    ...item,
                    quantity: 0,
                };
            });
            setNewArr(newCountArr);
            setRawData(res.data);
        })
            .catch((e) => console.log(e));
    }, []);
    const columns = React.useMemo(() => [
        { Header: "ID", accessor: "id" },
        { Header: "이미지", accessor: "thumbnail", Cell: ({ value }: any) => <img src={value} alt="상품 사진" style={{ maxWidth: "100px", maxHeight: "100px" }}/> },
        { Header: "상품명", accessor: "name" },
        { Header: "가격", accessor: "price" },
        { Header: "재고", accessor: "stock_count" },
        {
            Header: "관리",
            accessor: "actions",
            Cell: ({ row }: any) => {
                const id = row.original.id;
                return (<div className="d-flex gap-2">
            <Button size="sm" color="success" onClick={() => handleEdit(id)}>수정</Button>
            <Button size="sm" color="info" onClick={() => handleCopy(id)}>복사</Button>
            <Button size="sm" color="danger" onClick={() => handleDelete(id)}>삭제</Button>
          </div>);
            }
        }
    ], [handleEdit, handleCopy, handleDelete]);
    useEffect(() => {
        setData(newArr);
    }, [newArr]);
    return (<>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="상품목록" pageTitle="쇼핑몰"/>
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="d-flex align-items-center justify-content-between">
                  <h4 className="card-title mb-0 flex-grow-1">쇼핑 상품 목록</h4>
                  <div>
                    <Button color="success" className="add-btn me-1" onClick={() => {
            void guardOwnerAction(() => navigate(`/shopping-product-form/${0}`));
        }} id="create-btn">
                      <i className="ri-add-line align-bottom me-1"></i> 생성
                    </Button>
                  </div>
                </CardHeader>

                <CardBody>
                  <CustomTable data={data} columns={columns} onClickSort={undefined}/>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Remove Modal */}
      <Modal isOpen={modalDelete} onClose={() => {
            tog_delete();
        }} centered>
        <ModalBody className="text-center p-5">
          <div className="mt-4">
            <h4 className="mb-3">상품을 삭제하시겠습니까?</h4>
            <p className="text-muted mb-4">{`판매내역이 있는 상품의 경우 삭제가 되지 않을 수 있습니다. (id:${delRecord})`}</p>
            <div className="hstack gap-2 justify-content-center">
              <Button color="light" onClick={() => {
            setDelRecord(null);
            setModalDelete(false);
        }}>
                취소
              </Button>
              <Button color="danger" onClick={() => {
            API.delete(`${BACKEND_HOST}/shop/product/${delRecord}/`)
                .then((res) => {
                console.log(res.data);
                tog_delete();
            })
                .catch(async (e) => {
                console.log(e);
                await dialogService.handleAlert("상품 삭제 실패: " + (typeof e === "string" ? e : JSON.stringify(e)), { force: "error" });
                tog_delete();
            });
        }}>삭제</Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>);
}
;
const QuantityBox = ({ count, id }) => {
    const [quantity, setQuantity] = useState(count);
    console.log(id);
    const decreaseCount = () => {
        if (quantity === "") {
            setQuantity(0);
        }
        if (quantity > 0) {
            setQuantity((prev) => prev - 1);
        }
    };
    const increaseCount = () => {
        if (quantity === "") {
            setQuantity(0);
        }
        setQuantity((prev) => prev + 1);
    };
    const handleInputChange = (event) => {
        setQuantity("");
        const newQuantity = parseInt(event.target.value);
        console.log(newQuantity);
        console.log("state", quantity);
        if (!isNaN(newQuantity)) {
            setQuantity("");
            setQuantity(newQuantity);
        }
        else {
            setQuantity("");
        }
    };
    useEffect(() => {
        setQuantity(count);
    }, [count]);
    return (<span>
      <ButtonToolbar>
        <Button color="light" onClick={() => decreaseCount()}>
          -
        </Button>
        <Input id={`shopping_product_${id}`} type="number" style={{ width: "100px" }} value={quantity} onChange={handleInputChange}/>
        <Button color="light" onClick={() => increaseCount()}>
          +
        </Button>
      </ButtonToolbar>
    </span>);
};
